// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"29":"683c48d8","228":"5bc94cda","377":"bc7a6b4b","469":"635fcebd"}[chunkId] + ".chunk.css";
};